import { render, staticRenderFns } from "./noticeSetup.vue?vue&type=template&id=3fc4d000&scoped=true"
import script from "./noticeSetup.vue?vue&type=script&lang=js"
export * from "./noticeSetup.vue?vue&type=script&lang=js"
import style0 from "./noticeSetup.vue?vue&type=style&index=0&id=3fc4d000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc4d000",
  null
  
)

export default component.exports